import { ChartNoAxesCombined, Sparkles } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";

// Illustrative figures only. This preview never reads customer report data.
const departments = [
  {
    name: "HVAC service",
    revenue: "$84,000",
    profit: "$46,200",
    margin: "55.0%",
  },
  {
    name: "HVAC install",
    revenue: "$96,000",
    profit: "$38,400",
    margin: "40.0%",
  },
  { name: "Plumbing", revenue: "$68,600", profit: "$34,728", margin: "50.6%" },
];

export const ProfitabilityReportPreview = () => (
  <figure
    aria-label="Example profitability report with illustrative data"
    className="w-full min-w-0 overflow-hidden rounded-[20px] border border-[#2e3032] bg-[#141617] font-inter leading-4 text-white shadow-[0_20px_50px_-24px_rgba(0,0,0,0.35)]"
  >
    <Stack
      direction="row"
      align="center"
      justify="between"
      className="border-b border-white/10 px-6 py-3"
    >
      <Stack direction="row" align="center" gap="sm">
        <ChartNoAxesCombined className="h-4 w-4 text-orange-40" aria-hidden />
        <span className="text-[13px] font-semibold">
          Profitability at a glance
        </span>
      </Stack>
      <span className="rounded border border-white/15 px-2 py-1 text-[10px] font-medium uppercase tracking-wider text-white/65">
        Example report
      </span>
    </Stack>

    <Stack gap="none" className="px-6 pb-4 pt-4">
      <p className="text-[11px] text-white/55">Aug 1–31 · Monthly overview</p>
      <dl className="mb-2 mt-3 grid w-full grid-cols-3 gap-4">
        <Stack gap="xs">
          <dt className="text-[11px] text-white/65">Revenue</dt>
          <dd className="text-[25px] font-semibold tabular-nums leading-8 tracking-tight">
            $248,600
          </dd>
        </Stack>
        <Stack gap="xs">
          <dt className="text-[11px] text-white/65">Gross profit</dt>
          <dd className="text-[25px] font-semibold tabular-nums leading-8 tracking-tight">
            $119,328
          </dd>
        </Stack>
        <Stack gap="xs">
          <dt className="text-[11px] text-white/65">Gross margin</dt>
          <dd className="text-[25px] font-semibold tabular-nums leading-8 tracking-tight text-orange-40">
            48.0%
          </dd>
        </Stack>
      </dl>

      <table className="mt-4 w-full text-left text-[11px] tabular-nums">
        <caption className="sr-only">
          Example revenue, gross profit, and margin by department
        </caption>
        <thead className="text-[10px] font-normal text-white/55">
          <tr className="border-b border-white/15">
            <th scope="col" className="pb-2 font-medium">
              Department
            </th>
            <th scope="col" className="pb-2 text-right font-medium">
              Revenue
            </th>
            <th scope="col" className="pb-2 text-right font-medium">
              Gross profit
            </th>
            <th scope="col" className="pb-2 text-right font-medium">
              Margin
            </th>
          </tr>
        </thead>
        <tbody>
          {departments.map((department) => (
            <tr key={department.name} className="border-b border-white/[0.07]">
              <th scope="row" className="py-2 font-medium text-white/85">
                {department.name}
              </th>
              <td className="py-2 text-right text-white/65">
                {department.revenue}
              </td>
              <td className="py-2 text-right text-white/85">
                {department.profit}
              </td>
              <td className="py-2 text-right text-orange-40">
                {department.margin}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Stack
        gap="sm"
        fullWidth
        className="mt-4 rounded-lg border border-orange-50/20 bg-orange-50/[0.06] px-4 py-3"
      >
        <Stack direction="row" align="center" gap="sm">
          <Sparkles className="h-3.5 w-3.5 text-orange-40" aria-hidden />
          <span className="text-[10px] font-medium uppercase tracking-wider text-orange-40">
            Ask your report
          </span>
        </Stack>
        <p className="text-[12px] leading-5 text-white/90">
          “Which department has the strongest margin?”
        </p>
      </Stack>
      <figcaption className="mt-4 text-[10px] leading-4 text-white/45">
        Illustrative data. Your report is configured for your business.
      </figcaption>
    </Stack>
  </figure>
);
